import React, { useState } from 'react'
import styles from './HelpCenter.module.css'
import Header from '../Layout/Header'
import headphoneIcon from '../../assets/icons/headphone.svg'
import infoIcon from '../../assets/icons/info.svg'
import shieldIcon from '../../assets/icons/shield.svg'
import shieldColorIcon from '../../assets/icons/shieldColor.svg'

const HelpCenter = () => {
  const [expandedFaq, setExpandedFaq] = useState(null)
  const [activeCategory, setActiveCategory] = useState(null)

  const categories = [
    {
      id: 'start',
      icon: 'fas fa-rocket',
      title: '시작하기',
      description: '처음 시작하는 분들을 위한 가이드'
    },
    {
      id: 'profile',
      icon: 'fas fa-user',
      title: '계정 관리',
      description: '계정 설정 및 분석'
    },
    {
      id: 'gallery',
      icon: 'fas fa-images',
      title: '갤러리 이용',
      description: '갤러리 사용 및 관리'
    },
    {
      id: 'quality',
      icon: shieldIcon,
      title: '정책',
      description: 'DrawAndYou의 정책'
    }
  ]

  const faqs = {
    start: [
      {
        id: 1,
        question: '처음 접속했어요. 무엇부터 하면 될까요?',
        answer: '회원가입 후 대시보드의 "빠른 시작"에서 HTP 테스트나 자유 그리기를 눌러보세요. 첫 실행 시 주제/방법 안내 모달이 단계별로 안내합니다.'
      },
      {
        id: 2,
        question: 'HTP 테스트와 자유 그리기의 차이는 무엇인가요?',
        answer: 'HTP 테스트는 정해진 주제(집·나무·사람·빗속의 사람)를 따라 그리고 AI 분석을 받는 모드입니다. 자유 그리기는 주제/방법 선택 없이 바로 그리기만 할 수 있는 모드입니다.'
      },
      {
        id: 3,
        question: '분석 결과는 어디서 볼 수 있나요?',
        answer: '그림 업로드 후 추가 질문을 제출하면 결과 페이지로 이동합니다. 치료 코스 중이라면 코스 완료 버튼으로 진행도가 갱신되며, 결과는 프로그램 결과 화면에서도 확인할 수 있습니다.'
      }
    ],
    profile: [
      {
        id: 4,
        question: '프로필 사진·비밀번호·관심사는 어디서 바꾸나요?',
        answer: '우측 상단 프로필에서 "내 정보"로 이동한 뒤 각 항목의 수정 버튼을 눌러 업데이트할 수 있습니다. 변경 후 확인을 눌러주세요.'
      },
      {
        id: 5,
        question: '비밀번호를 잊어버렸어요. 어떻게 재설정하나요?',
        answer: '로그인 화면에서 비밀번호 찾기를 통해 재설정 메일을 받을 수 있습니다. 소셜 로그인 사용자는 해당 소셜 계정에서 비밀번호를 변경해주세요.'
      },
      {
        id: 6,
        question: '로그인 유지가 안 될 때는 어떻게 하나요?',
        answer: '브라우저 쿠키/스토리지를 지웠거나 토큰이 만료된 경우입니다. 다시 로그인하면 대시보드로 자동 이동하며, 필요 시 로그아웃 후 재로그인해 주세요.'
      }
    ],
    gallery: [
      {
        id: 7,
        question: '완성한 그림은 어디에 저장되나요?',
        answer: 'AI 분석 후 결과 보기 단계에서 자동으로 갤러리에 추가됩니다. 자유 그리기 저장 버튼으로도 PNG를 다운로드할 수 있습니다.'
      },
      {
        id: 8,
        question: '다운로드가 안 되거나 새 탭으로만 열려요.',
        answer: '브라우저 보안/CORS 설정으로 직접 저장이 제한될 수 있습니다. 새 탭에서 이미지를 우클릭해 기기에 저장하세요.'
      },
      {
        id: 9,
        question: '커뮤니티에 그림을 올리려면 어떻게 하나요?',
        answer: '커뮤니티 탭에서 "그림 업로드" 버튼을 눌러 제목·내용을 작성하고 이미지(선택)를 추가한 뒤 업로드하세요. 업로드 후 내 게시글 탭에서 관리할 수 있습니다.'
      }
    ],
    quality: [
      {
        id: 10,
        question: '내 데이터는 어떻게 보호되나요?',
        answer: '모든 API 요청은 토큰 기반 인증을 사용하며, 이미지 업로드는 presigned URL로 처리합니다. 민감 정보는 암호화되어 저장됩니다.'
      },
      {
        id: 11,
        question: '분석 결과와 그림의 소유권은 누구에게 있나요?',
        answer: '사용자가 업로드한 그림과 분석 결과는 기본적으로 사용자에게 소유권이 있습니다. 단, 서비스 품질 개선을 위한 익명 통계는 별도 동의 후 활용될 수 있습니다.'
      },
      {
        id: 12,
        question: '상업적 사용이 가능한가요?',
        answer: '개인적/비영리적 사용은 자유롭게 가능합니다. 상업적 활용이 필요하면 별도 문의를 통해 이용 약관 및 라이선스 조건을 확인해주세요.'
      }
    ]
  }

  const toggleFaq = (faqId) => {
    setExpandedFaq(expandedFaq === faqId ? null : faqId)
  }

  const toggleCategory = (categoryId) => {
    setActiveCategory(activeCategory === categoryId ? null : categoryId)
  }

  return (
    <>
      <Header />
      <div className={styles.container}>
        <div className={styles.header}>
          <img src={infoIcon} alt = "정보 아이콘" draggable={false}/>
          <h1>도움말 센터</h1>
        </div>

      {/* 카테고리 카드 */}
      <div className={styles.categoryGrid}>
        {categories.map((category) => (
          <div 
            key={category.id}
            className={styles.categoryCard}
            onClick={() => {
              setActiveCategory(category.id)
              // 카테고리 클릭 시 해당 FAQ 섹션으로 스크롤
              const element = document.getElementById(`faq-${category.id}`)
              if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' })
              }
            }}
          >
            <div className={styles.categoryIcon}>
              {category.id === 'quality' ? (
                <img src={shieldIcon} alt="정책 아이콘" draggable={false} />
              ) : (
                <i className={category.icon}></i>
              )}
            </div>
            <h3>{category.title}</h3>
            <p>{category.description}</p>
          </div>
        ))}
      </div>

      {/* FAQ 섹션들 */}
      <div className={styles.faqContainer}>
        {categories.map((category) => (
          <div 
            key={category.id} 
            id={`faq-${category.id}`}
            className={styles.faqSection}
          >
            <div className={styles.sectionHeader}>
              {category.id === 'quality' ? (
                <img src={shieldColorIcon} alt="정책 아이콘" draggable={false} />
              ) : (
                <i className={category.icon}></i>
              )}
              <h2>{category.title}</h2>
            </div>

            <div className={styles.faqList}>
              {faqs[category.id]?.map((faq) => (
                <div 
                  key={faq.id}
                  className={`${styles.faqItem} ${expandedFaq === faq.id ? styles.expanded : ''}`}
                >
                  <button 
                    className={styles.faqQuestion}
                    onClick={() => toggleFaq(faq.id)}
                  >
                    <span>{faq.question}</span>
                    <i className={`fas fa-chevron-down ${expandedFaq === faq.id ? styles.rotated : ''}`}></i>
                  </button>
                  {expandedFaq === faq.id && (
                    <div className={styles.faqAnswer}>
                      <p>{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* 고객 지원 섹션 */}
      <div className={styles.supportSection}>
        <div className={styles.supportHeader}>
          <img src={headphoneIcon} alt = "헤드셋 아이콘" draggable={false}/>
          <h2>고객 지원</h2>
        </div>
        <div className={styles.supportContent}>
          <div className={styles.contactItem}>
            <i className="fas fa-envelope"></i>
            <div>
              <strong>이메일</strong>
              <p>contact.drawandyou@gmail.com</p>
            </div>
          </div>
          <div className={styles.contactItem}>
            <i className="fas fa-phone"></i>
            <div>
              <strong>전화</strong>
              <p>010-6377-6910</p>
            </div>
          </div>
          <div className={styles.contactItem}>
            <i className="fab fa-instagram"></i>
            <div>
              <strong>Instagram</strong>
              <p>@drawANDyou_official</p>
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  )
}

export default HelpCenter
